import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { ReactComponent as User } from '../../../../assets/images/scouts/user.svg'
import { ReactComponent as Settings } from '../../../../assets/images/scouts/setting.svg'
import { ReactComponent as LogOut } from '../../../../assets/images/scouts/logout.svg'
import './ProfileToggle.scss'
import { Avatar, message } from 'antd'
import ReturnDashboardIcon from '../../../../assets/images/Icons/ReturnDashboardIcon'
import { connect } from 'react-redux'
import { portalRedirection } from '../../../../redux/investorFlowControl/investorFlowControlActions'
import { fetchEducationUserLogout, updateLocalInvestorUser } from '../../../../redux/auth/authActions'

const ProfileToggle = props => {
  const { profileData } = props
  const [activeProfile, setActiveProfile] = useState(false)
  const [activeCompanyInfo, setActiveCompanyInfo] = useState(false)

  const handleProfileClick = () => {
    setActiveProfile(!activeProfile)
  }

  const handleCompanyInfoClick = () => {
    setActiveCompanyInfo(!activeCompanyInfo)
    props.history.push('/education/learn-invest/profile')
  }

  const handleProfileSettingClick = () => {
    setActiveCompanyInfo(!activeCompanyInfo)
    props.history.push('/education/learn-invest/setting')
  }

  const onLogout = async () => {
    props.setLogoutLoader(true)
    const success = await props.fetchEducationUserLogout('learnInvest')
    if (success) {
      localStorage.removeItem('learnInvest_token')
      props.setLogoutLoader(false)
      props.history.replace('/education/learn-invest/login')
    } else {
      props.setLogoutLoader(false)
    }
  }

  return (
    <div className="custom-education-dropdown ml-2">
      <Dropdown isOpen={activeProfile} toggle={handleProfileClick}>
        <DropdownToggle>
          <Avatar className="education-avatar-wrap" src={profileData?.profile_pic}>
            {profileData?.first_name?.[0]?.toUpperCase()}
          </Avatar>
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={handleCompanyInfoClick}>
            <User />
            Profile
          </DropdownItem>
          <DropdownItem onClick={handleProfileSettingClick}>
            <Settings />
            Settings
          </DropdownItem>
          <DropdownItem onClick={onLogout}>
            <LogOut />
            Logout
          </DropdownItem>
          {['investor', 'startup'].includes(localStorage.getItem('login_type')) && (
            <DropdownItem
              className="menuDropdownButton"
              onClick={() => {
                props
                  .portalRedirection('education', localStorage.getItem('login_type'))
                  .then(res => {
                    if (res.result) {
                      props.updateLocalInvestorUser(res.user)
                      if (['pending', 'rejected'].includes(res?.user?.status?.status)) {
                        window.open('/investor/thankyou', '_blank')
                      } else if (res?.user?.status?.status === 'incomplete') {
                        window.open('/investor/onboarding', '_blank')
                      } else {
                        window.open('/investor/deals', '_blank')
                      }
                    } else {
                      if (res.error === 'user is paused') {
                        window.open('/suspend', '_blank')
                      }
                    }
                  })
                  .catch(err => {
                    if (err?.error === 'user is paused') {
                      window.open('/suspend', '_blank')
                    }
                  })
              }}
            >
              <ReturnDashboardIcon />
              <span>
                Return to{' '}
                <span style={{ textTransform: 'capitalize' }}>{localStorage.getItem('login_type')}</span>{' '}
                Dashboard
              </span>
            </DropdownItem>
          )}
        </DropdownMenu>
      </Dropdown>
    </div>
  )
}

const mapDispatchToProps = dispatch => ({
  portalRedirection: (url, data) => {
    return dispatch(portalRedirection(url, data))
  },
  updateLocalInvestorUser: changedProperties => {
    return dispatch(updateLocalInvestorUser(changedProperties))
  },
  fetchEducationUserLogout: userType => {
    return dispatch(fetchEducationUserLogout(userType))
  },
})

export default withRouter(connect(null, mapDispatchToProps)(ProfileToggle))
